var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 8.2846C16.7025 8.2296 16.4767 8.0571 16.36 7.81043C15.0683 5.0846 12.0742 3.56043 9.08167 4.1121C6.355 4.6121 4.2175 6.78877 3.76167 9.5296C3.62667 10.3388 3.63667 11.1488 3.78917 11.9379C3.83917 12.1954 3.72833 12.4821 3.50083 12.6888C2.54667 13.5563 2 14.7921 2 16.0804C2 18.6071 4.05583 20.6638 6.58333 20.6638H15.75C19.1967 20.6638 22 17.8604 22 14.4138C22 11.4429 19.8883 8.8646 16.9783 8.2846ZM14.6008 13.7529C14.4383 13.9154 14.225 13.9971 14.0117 13.9971C13.7983 13.9971 13.585 13.9154 13.4225 13.7529L12 12.3304V16.4971C12 16.9579 11.6267 17.3304 11.1667 17.3304C10.7067 17.3304 10.3333 16.9579 10.3333 16.4971V12.3304L8.91083 13.7529C8.585 14.0788 8.05833 14.0788 7.7325 13.7529C7.40667 13.4271 7.40667 12.9004 7.7325 12.5746L9.98833 10.3188C10.31 9.9971 10.7325 9.83543 11.155 9.83293L11.1667 9.83043L11.1783 9.83293C11.6017 9.83543 12.0233 9.9971 12.345 10.3188L14.6008 12.5746C14.9267 12.9004 14.9267 13.4271 14.6008 13.7529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadIcon);
export default __webpack_public_path__ + "static/media/cloud-upload-icon.62449d08777ba26de6c32bf74ef39aee.svg";
export { ForwardRef as ReactComponent };